(function () {
	const controlsProductVideo = (section) => {
		// Handle product video controls (absolute positioned at bottom right for media-banner)
		const productControls = section.querySelectorAll(".video-controls-product");
		
		productControls.forEach((controls) => {
			// Skip if already initialized
			if (controls.dataset.initialized === 'true') return;
			controls.dataset.initialized = 'true';
			
			const mediaContainer = controls.closest('.media-banner__video');
			if (!mediaContainer) return;
			
			// Get all videos (there might be desktop and mobile versions)
			const videos = mediaContainer.querySelectorAll('video');
			const iframes = mediaContainer.querySelectorAll('iframe');
			const playButton = controls.querySelector(".js-play-video");
			const soundButton = controls.querySelector(".js-sound-video");

			// Function to get the currently visible video
			const getVisibleVideo = () => {
				if (videos.length === 1) return videos[0];
				if (videos.length > 1) {
					// Check which video is visible (desktop vs mobile)
					for (let vid of videos) {
						const style = window.getComputedStyle(vid);
						if (style.display !== 'none') {
							return vid;
						}
					}
				}
				return videos[0]; // fallback
			};

			// Handle video play/pause
			if (playButton && videos.length > 0 && iframes.length === 0) {
				playButton.addEventListener("click", (e) => {
					e.preventDefault();
					e.stopPropagation();
					
					const video = getVisibleVideo();
					if (!video) return;
					
					if (video.paused) {
						video.play();
						playButton.classList.add("active");
					} else {
						video.pause();
						playButton.classList.remove("active");
					}
				});
			}

			// Handle iframe play/pause
			if (playButton && iframes.length > 0) {
				const iframe = iframes[0];
				playButton.addEventListener("click", (e) => {
					e.preventDefault();
					e.stopPropagation();
					
					if (iframe.classList.contains('js-youtube')) {
						if (playButton.classList.contains('active')) {
							iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
							playButton.classList.remove("active");
						} else {
							iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', "*");
							playButton.classList.add("active");
						}
					} else if (iframe.classList.contains('js-vimeo')) {
						if (playButton.classList.contains('active')) {
							iframe.contentWindow.postMessage('{"method":"pause"}', "*");
							playButton.classList.remove("active");
						} else {
							iframe.contentWindow.postMessage('{"method":"play"}', "*");
							playButton.classList.add("active");
						}
					}
				});
			}

			// Handle video sound
			if (soundButton && videos.length > 0 && iframes.length === 0) {
				soundButton.addEventListener("click", (e) => {
					e.preventDefault();
					e.stopPropagation();
					
					const iconSoundOff = soundButton.querySelector("span:first-child");
					const iconSoundOn = soundButton.querySelector("span:last-child");
					
					const video = getVisibleVideo();
					if (!video) return;
					
					// Toggle mute on all videos
					const newMutedState = !video.muted;
					videos.forEach(vid => {
						vid.muted = newMutedState;
					});
					
					// Update icon visibility
					if (newMutedState) {
						iconSoundOff.classList.remove("icon-hidden");
						iconSoundOn.classList.add("icon-hidden");
					} else {
						iconSoundOff.classList.add("icon-hidden");
						iconSoundOn.classList.remove("icon-hidden");
					}
				});
			}

			// Handle iframe sound
			if (soundButton && iframes.length > 0) {
				const iframe = iframes[0];
				soundButton.addEventListener("click", (e) => {
					e.preventDefault();
					e.stopPropagation();
					
					const iconSoundOff = soundButton.querySelector("span:first-child");
					const iconSoundOn = soundButton.querySelector("span:last-child");
					
					if (iframe.classList.contains('js-youtube')) {
						if (iframe.classList.contains('video-muted')) {
							iframe.contentWindow.postMessage('{"event":"command","func":"unMute","args":""}', "*");
							iframe.classList.remove('video-muted');
							iconSoundOff.classList.add("icon-hidden");
							iconSoundOn.classList.remove("icon-hidden");
						} else {
							iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', "*");
							iframe.classList.add('video-muted');
							iconSoundOff.classList.remove("icon-hidden");
							iconSoundOn.classList.add("icon-hidden");
						}
					} else if (iframe.classList.contains('js-vimeo')) {
						if (iframe.classList.contains('video-muted')) {
							iframe.contentWindow.postMessage('{"method":"setVolume","value":1}', "*");
							iframe.classList.remove('video-muted');
							iconSoundOff.classList.add("icon-hidden");
							iconSoundOn.classList.remove("icon-hidden");
						} else {
							iframe.contentWindow.postMessage('{"method":"setVolume","value":0}', "*");
							iframe.classList.add('video-muted');
							iconSoundOff.classList.remove("icon-hidden");
							iconSoundOn.classList.add("icon-hidden");
						}
					}
				});
			}
		});
	};

	const mediaBanner = () => {
		document.querySelectorAll(".media-banner").forEach((block) => {
			let box = block.closest("section");
			let id = box.getAttribute("id");
			block = $(block);

			const stickyEffect = block.data("sticky-effect");

			if (stickyEffect) {
				var normalElement = document.querySelector(`#${id} + .sticky-section`);
				if (normalElement == null) {
					return;
				}

				var isSticky = false;

				window.addEventListener("scroll", function () {
					// Check if elements still exist in DOM
					if (!box || !normalElement || !document.body.contains(box) || !document.body.contains(normalElement)) {
						return;
					}
					
					var stickyTop = box.getBoundingClientRect().top;
					var normalElementTop = normalElement.getBoundingClientRect().top;

					if (stickyTop <= 0 && !isSticky) {
						box.classList.add("sticky-active");
						isSticky = true;
					}

					if (normalElementTop <= 0 && isSticky) {
						box.classList.remove("sticky-active");
						isSticky = false;
					}
				});
			}
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		mediaBanner();
		controlsProductVideo(document);
		document.addEventListener("shopify:section:load", function (event) {
			mediaBanner();
			controlsProductVideo(event.target);
		});
	});
})();

//document.addEventListener("DOMContentLoaded", function () {
//	var stickyElement = document.querySelector(
//		"#shopify-section-template--23032186601765__media-banner"
//	);
//	var normalElement = document.querySelector(
//		"#shopify-section-template--23032186601765__media-banner-2"
//	);
//	var isSticky = false; // Track whether the element is sticky

//	window.addEventListener("scroll", function () {
//		var stickyTop = stickyElement.getBoundingClientRect().top;
//		var normalElementTop = normalElement.getBoundingClientRect().top;

//		// Add sticky class when sticky element reaches the top of the viewport
//		if (stickyTop <= 0 && !isSticky) {
//			stickyElement.classList.add("sticky-active");
//			isSticky = true; // Set sticky state to true
//		}

//		// Remove sticky class if the second section is in the viewport
//		if (normalElementTop <= 0 && isSticky) {
//			stickyElement.classList.remove("sticky-active");
//			isSticky = false; // Set sticky state to false
//		}
//	});
//});
